export default "__VITE_ASSET__Ct0WTX7o__"